import { useEffect } from 'react';

const useDynamicValidate = (validateForm, observer) => {
  useEffect(() => {
    validateForm();
  }, [validateForm, observer]);
};

export default useDynamicValidate;
